import { Component, Input, ElementRef, Optional, Self } from '@angular/core';
import { Observable } from 'rxjs';
import { Results, PlatformApiService, ResultFilter } from '../services/platform-api.service';
import { Account } from '../models/AccountModel';
import { InfiniteScrollSelectComponent, InfiniteScrollOption } from './infinite-scroll-select.component';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FocusMonitor } from '@angular/cdk/a11y';
import { NgControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'cw-cs-partner-dropdown',
  templateUrl: './infinite-scroll-select.component.html',
  styleUrls: ['./infinite-scroll-select.component.scss'],
  providers:[{provide: MatFormFieldControl, useExisting: CSPartnerDropdownComponent}]
})

export class CSPartnerDropdownComponent extends InfiniteScrollSelectComponent<number> {
  @Input() placeholder = 'Partner Id'
  @Input() partnerAccount:Account;
  @Input() disableInUseCompanies: boolean;
  @Input() MultiSelection: string;
  @Input() key:string;
  selectedValue: any[] = [];

  constructor(private _apiService: PlatformApiService, fm: FocusMonitor, elRef: ElementRef<HTMLElement>,
    @Optional() @Self() ngControl: NgControl) {
    super(fm, elRef, ngControl);
  }

  searchFunction(currentFilters: ResultFilter) : Observable<Results<any>> {
    const userDetails = localStorage.getItem('workingCredential')
    var obj = JSON.parse(userDetails);
    currentFilters.searchData.searchField = this.key;
    currentFilters.searchData.userProfile= obj.user.id;
    return this._apiService.getCSAllTenants(currentFilters);
  }

  mapSearchResults(results: Results<any>) {
    if(results.count > 0) {
      this.options.next(results.results.map(result => {
        let csInstanceDetails='';
        let isActive = true;
        if (this.key.toLowerCase() =='centralserviceinstanceid') {
          csInstanceDetails = result.instanceIdentifier != null ? result.id +'('+ result.instanceIdentifier +')' : result.id ;
          if (result.instanceStatus.identifier.toLowerCase()=='locked'||result.instanceStatus.identifier.toLowerCase()=='stopped'||result.instanceStatus.identifier.toLowerCase()=='terminated'
              ||result.paymentStatus.identifier.toLowerCase()=='missing'||result.paymentStatus.identifier.toLowerCase()=='cancelled'
              ||(result.paymentStatus.identifier.toLowerCase()=='trial'&& moment.utc(new Date()).format('YYYY-MM-DD') >= moment.utc(result.trialInfo.end*1000).format('YYYY-MM-DD'))) {
                  isActive = false;
                  csInstanceDetails += ' | Status: Inactive';
          }
        } else {
          csInstanceDetails = result.id + '('+ result.companyName+ ')';
        }

        const data = (this.key.toLowerCase() =='centralserviceinstanceid')? {partnerId: result.partnerId, key: this.key} : '';
        const mappedToIdentify = this.disableInUseCompanies? result.mappedToIdentify : false;

        return new InfiniteScrollOption(csInstanceDetails, result.id, mappedToIdentify, false, isActive, data);
      }));
    } else {
      this.options.next([new InfiniteScrollOption('No results found.', null, true, false, true)]);
    }
    this.totalResults = results.count;
  }

  createResultsFilter(filter: string) {
    const resultFilter = new ResultFilter();
    resultFilter.searchData.name = filter;
    return resultFilter;
  }

  optionClicked(event: Event, option) {
    event.stopPropagation();
  }

  toggleSelection(option) {}
}